<template>
  <div class="main">
    <a-layout class="contain">
      <a-layout-sider
        theme="light"
        style="max-width: 380px; width: 380px; flex: 0 0 380px"
      >
        <div>
          <a-input-search
            style="margin-bottom: 8px；"
            placeholder="输入关键词搜索"
            v-model="searchValue"
            @change="onChange"
            @keyup.esc="cleanSearch()"
          />
        </div>
        <div class="catalist" style="width: 380px">
          <!-- <a-list size="small" :data-source="treeData" v-if="searchValue">
            <a-list-item slot="renderItem" slot-scope="item, index" :key="index" @click="clickCate([item.catid],{type:1,node:{$children:[]}})">
              <a-list-item-meta :description="item.intro.substr(1)">
                <span slot="title">{{ item.catname }}</span>
              </a-list-item-meta>
            </a-list-item>
          </a-list>-->
          <a-tree
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            :tree-data="treeData"
            :replace-fields="{ key: 'catid' }"
            @expand="onExpand"
            @select="clickCate"
          >
            <template slot="title" slot-scope="{ title, intro }">
              <span :title="intro.substr(1)">
                <span v-if="title.indexOf(searchValue) > -1">
                  {{ title.substr(0, title.indexOf(searchValue)) }}
                  <span style="color: #f50">{{ searchValue }}</span>
                  {{
                    title.substr(
                      title.indexOf(searchValue) + searchValue.length
                    )
                  }}
                </span>
                <span v-else>{{ title }}</span>
              </span>
              <span v-show="searchValue" style="font-size: 12px; color: #999"
                >({{ intro.substr(1) }})</span
              >
            </template>
          </a-tree>
        </div>
      </a-layout-sider>
      <a-layout
        style="position: relative; background-color: #fff"
        v-if="loading"
      >
        <div
          style="
            width: 100%;
            text-align: center;
            background: rgba(0, 0, 0, 0.05);
            min-height: 100vh;
            line-height: 100vh;
          "
        >
          <a-spin />
        </div>
      </a-layout>
      <a-layout style="position: relative; background-color: #fff" v-else>
        <a-layout-content class="article-lists left">
          <div class="menu-title article-lists-title">
            <div style="position: absolute">请选择需要排序的文章</div>
            <div style="position: absolute; right: 20px">
              <a-input-search
                placeholder="请输入文章标题筛选"
                style="width: 300px"
                v-model="keywords"
                @search="onSearch"
                @keyup.esc="onEsc"
              />
            </div>
          </div>
          <myScroll class="scroll">
            <div>
              <div
                class="article-title"
                v-for="(item, index) in articleLists"
                :key="index"
              >
                {{ item.title }}
                <span class="pubtime">({{ item.pubtime }})</span>
                <div class="button">
                  <button @click="set(index)">选取</button>
                </div>
              </div>
            </div>
            <div
              v-if="articleLists.length == 0"
              style="margin-left: 20px; line-height: 32px; height: 32px"
            >
              没有符合条件的内容
            </div>
          </myScroll>
        </a-layout-content>
        <a-layout-content class="article-lists right">
          <div class="menu-title article-lists-title">
            <div style="position: absolute; left: 40px">
              已选取 {{ sortArticleLists.length }} 篇排序文章
            </div>
            <div style="position: absolute; right: 20px">
              <a-button @click="saveSort">保存排序</a-button>
            </div>
          </div>
          <myScroll>
            <div style="margin-bottom: 50px">
              <SlickList
                :lockToContainerEdges="true"
                lockAxis="y"
                v-model="sortArticleLists"
                @input="getChangeLists"
                :useDragHandle="true"
              >
                <SlickItem
                  :index="index"
                  v-for="(item, index) in sortArticleLists"
                  :key="index"
                  class="sort-lists"
                  v-handle
                >
                  <div class="article-title">
                    <a-avatar
                      size="small"
                      :style="{ verticalAlign: 'middle' }"
                      >{{ index + 1 }}</a-avatar
                    >
                    <span v-if="item.title.length > 20"
                      >{{ item.title.substr(0, 16) }}...</span
                    ><span v-else>{{ item.title }}</span
                    ><span class="pubtime" style="margin-left: 5px"
                      >({{ item.pubtime }})</span
                    >
                    <div class="button">
                      <button @click="remove(index)">取消</button>
                    </div>
                  </div>
                </SlickItem>
              </SlickList>
            </div>
          </myScroll>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import { SlickList, SlickItem, HandleDirective } from 'vue-slicksort';

export default {
  name: 'Sort',
  directives: { handle: HandleDirective },
  components: {
    SlickItem,
    SlickList
  },
  data() {
    return {
      cataLists: [],
      currentIndex: 0,
      articleLists: [],
      sortArticleLists: [],
      changed: false,
      keywords: '',
      treeData: [],
      loading: false,
      valueTree: undefined,
      expandedKeys: [],
      autoExpandParent: true,
      oldtreeData: [],
      searchValue: '',
      tempObj: []
    };
  },
  created() {
    this.getCateList();
  },
  methods: {
    cleanSearch() {
      this.onChange('c');
    },
    getParentKey(key, tree) {
      let parentKey;
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
          if (node.children.some(item => item.key === key)) {
            parentKey = node.key;
          } else if (this.getParentKey(key, node.children)) {
            parentKey = this.getParentKey(key, node.children);
          }
        }
      }
      return parentKey;
    },
    deepSearch(tree) {
      this.tempObj = [];
      var stark = [];
      stark = stark.concat(tree);

      while (stark.length) {
        var temp = stark.shift();
        if (temp.children) {
          // 当前节点有子节点时，将子节点放到当前的栈的前面
          stark = temp.children.concat(stark);
        }
        this.tempObj.push(temp);
        // console.log(temp);
      }
    },
    onChange(e) {
      if (typeof e == 'string') {
        this.searchValue = '';
        this.treeData = this.oldtreeData;
      } else {
        const value = e.target.value;
        if (value != '') {
          let tempObj = [];
          this.deepSearch(this.oldtreeData);
          for (let item of this.tempObj) {
            if (item.title.indexOf(value) >= 0) {
              if (typeof item[item.catid] == 'undefined') {
                tempObj.push(item);
              }
            }
          }
          this.treeData = tempObj;
        } else {
          this.treeData = this.oldtreeData;
        }
      }
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    saveSort() {
      let idArr = [];
      for (let i in this.sortArticleLists) {
        idArr.push(this.sortArticleLists[i].id);
      }
      let param = {
        catid: this.currentIndex,
        ids: idArr.join(',')
      };
      this.$http.post('/api/content/cloudcategoryorder', param).then(res => {
        if (res.data.state == 200) {
          this.$message.success('操作成功！');
          this.changed = false;
        }
      });
    },
    getChangeLists(val) {
      // console.log(val);
    },
    set(index) {
      let len = 40;
      this.changed = true;
      let item = this.articleLists[index];
      if (this.sortArticleLists.length < len) {
        let status = false;
        for (let i in this.sortArticleLists) {
          if (this.sortArticleLists[i].id == item.id) {
            status = true;
          }
        }
        if (!status) {
          this.sortArticleLists.push(item);
        } else {
          this.$message.warn('该文章已存在排序列表中。');
        }
        this.articleLists.splice(index, 1);
      } else {
        this.$message.warn('最多能对 ' + len + ' 篇文章进行排序');
      }
    },
    remove(index) {
      this.changed = true;
      let param = {
        ids: this.sortArticleLists[index].id,
        catid: this.currentIndex,
        restore: 1
      };
      this.$http.post('/api/content/cloudcategoryorder', param).then(res => {
        if (res.data.state == 200 || res.data.state == 400) {
          let item = this.sortArticleLists[index];
          this.sortArticleLists.splice(index, 1);
          this.articleLists.unshift(item);
        }
      });
    },
    onEsc() {
      this.articleLists = [];
      this.keywords = '';
      this.getArticleList(this.currentIndex);
    },
    onSearch() {
      this.articleLists = [];
      this.getArticleList(this.currentIndex);
    },
    clickCate(value, e) {
      console.log(value, e)
      if (e.node.$children.length > 0 && typeof e.type == 'undefined') {
        Object.assign(this, {
          articleLists: [],
          sortArticleLists: []
        });
        return false;
      } else {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 2000);
        this.valueTree = value[0];
        if (this.changed) {
          let that = this;
          this.$confirm({
            title: '确定切换栏目吗?',
            content: '请保存当前的排序内容再切换栏目，点击确定放弃当前修改',
            onOk() {
              that.keywords = '';
              that.changed = false;
              that.currentIndex = value[0];
              that.getArticleList(value[0]);
              that.getSortArticleList(value[0]);
            },
            onCancel() { }
          });
        } else {
          if (value[0]) {
            this.currentIndex = value[0];
            this.keywords = '';
            this.getArticleList(value[0]);
            this.getSortArticleList(value[0]);
          }
        }
      }
    },
    getCateList() {
      this.$http
        .post('/api/content/categorylist', { limit: 9999 })
        .then(res => {
          let data = res.data.data;
          let list = this.toTree(data);
          this.cataLists = list;
          this.treeData = this.treeKey(list);
          this.oldtreeData = JSON.parse(JSON.stringify(this.treeData));
        });
    },
    getArticleList(catid) {
      let param = {
        catid: catid,
        limit: 60,
        'cate-orders': 'no',
        title: this.keywords,
        show: '0100'
      };
      this.$http.post('/api/content/cloudlist', param).then(res => {
        if (res.data.state == 200) {
          this.articleLists = res.data.data;
        } else {
          this.articleLists = [];
        }
      });
    },
    getSortArticleList(catid) {
      console.log(catid)
      this.$http
        .post('/api/content/cloudlist', {
          catid: catid,
          limit: 60,
          'cate-orders': 'yes'
        })
        .then(res => {
          if (res.data.state == 200) {
            this.sortArticleLists = res.data.data;
          } else {
            this.sortArticleLists = [];
          }
        });
    },
    filterTreeNode(inputValue, treeNode) {
      return (
        treeNode.componentOptions.propsData.title
          .toLowerCase()
          .indexOf(inputValue.toLowerCase()) >= 0
      );
    },
    toTree(data) {
      data.forEach(item => {
        delete item.children;
      });
      let map = {};
      data.forEach(item => {
        item.scopedSlots = { title: 'title' };
        map[item.catid] = item;
      });
      let val = [];
      data.forEach(item => {
        let parent = map[item.parentid];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          val.push(item);
        }
      });
      return val;
    },
    treeKey(data) {
      let val = [];
      let that = this;
      function setName(obj, ide, intro) {
        for (let i = 0; i < obj.length; i++) {
          obj[i].title = obj[i].catname;
          obj[i].key = ide + '-' + i;
          obj[i].intro = intro + '>' + obj[i].catname;
          obj[i].value = obj[i].catid;
          obj[i].label = obj[i].catname;
          if (obj[i].children) {
            obj[i].disabled = true;
          }
          if (obj[i].children) {
            that.expandedKeys.push(obj[i].catid);
            setName(obj[i].children, obj[i].key, obj[i].intro);
          }
        }
        val = obj;
      }
      setName(data, '0', '');
      return val;
    }
  }
};
</script>
<style>
.scroll > div.__panel > div.__view {
  width: auto !important;
}
</style>
<style scoped>
.main {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.contain {
  margin-top: 2px;
  position: absolute;
  padding: 10px 0 0 20px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 5px;
  background-color: #fff;
  overflow: hidden;
}

.menu {
  width: 200px;
  /*position: absolute;*/
  /*top: 0;*/
  /*left: 0;*/
  /*right: 0;*/
  /*bottom: 0;*/
  /*overflow: hidden;*/
  /*overflow-y: auto;*/
}

.menu-title {
  font-weight: bold;
  text-align: center;
}

.menu-list {
  cursor: pointer;
}

.menu-list:hover,
.menu-list.current {
  background-color: #efefef;
}

.article-lists {
  padding: 5px;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: hidden;
  overflow-y: auto;
}

.left {
  width: calc(100% - 550px);
  overflow: hidden;
}

.left .article-lists-title {
  border-bottom: 1px solid #ccc;
  padding-left: 20px;
  margin: 0 20px;
}

.pubtime {
  /*display: none;*/
  font-size: 12px;
  color: #ccc;
}

.article-lists-title {
  height: 50px;
  line-height: 50px;
  /*border:1px solid #ccc;*/
}

.article-lists.right {
  width: 500px;
  right: 20px;
  border: 1px solid #ededed;
  bottom: 10px;
  overflow: hidden;
}

.article-lists.right .article-lists-title {
  border-bottom: 1px solid #ededed;
}

.article-lists.right .article-title {
  width: 460px;
}

.article-lists .article-title {
  height: 46px;
  line-height: 46px;
  margin-left: 20px;
  padding: 0 20px;
  border-bottom: 1px solid #ccc;
  margin-top: -1px;
  position: relative;
  overflow: hidden;
  /* text-overflow: ellipsis; */
  white-space: nowrap;
}

.article-title .button {
  display: none;
  height: 44px;
  line-height: 44px;
  width: 65px;
  text-align: center;
  position: absolute;
  right: 10px;
  top: 2px;
  z-index: 10;
  padding-left: 10px;
}

.article-title:hover .button {
  display: inline;
}

.article-title button {
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  background-color: #fff;
  position: relative;
  padding-left: 8px;
  text-align: left;
  width: 50px;
  border: none;
  color: #6b6b6b;
}

.left .article-title {
  position: relative;
  margin-right: 20px;
}

.left .article-title button {
  border-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
  right: 10px;
  z-index: 10;
}

.left .article-title button:hover {
  color: #1890ff;
}

.left .article-title button::after {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  top: 0;
  right: -30px;
  border-left: 15px solid #fff;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-right: 15px solid transparent;
}

.left .article-title:hover {
  color: #fff;
  background-color: #1890ff;
}

.right .article-title button {
  border-radius: 0;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.right .article-title button:hover {
  color: #f5222d;
}

.right .article-title button::before {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  top: 0;
  left: -30px;
  border-left: 15px solid transparent;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-right: 15px solid #fff;
}

.right .article-title:hover {
  color: #fff;
  background-color: #1890ff;
}

.ant-avatar {
  margin-right: 5px;
}

.right .sort-lists:nth-child(1) .ant-avatar {
  background-color: #f56a00;
}

.right .sort-lists:nth-child(2) .ant-avatar {
  background-color: #00a2ae;
}

.right .sort-lists:nth-child(3) .ant-avatar {
  background-color: #87d068;
}

.sort-lists {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Chrome/Safari/Opera */
  -khtml-user-select: none;
  /* Konqueror */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  cursor: move;
}

.catalist {
  overflow: scroll;
  position: absolute;
  top: 40px;
  left: 0;
  bottom: 0;
  width: 200px;
}
</style>
